// extracted by mini-css-extract-plugin
module.exports = {"menu":"top_menu__naCUm","focus-visible":"top_focus-visible__Fefzl"};